import * as React from "react";

import { cn } from "@/lib/utils";

/** C25 批1:输入原语——细边圆角,focus 橙环(全站 22+ 处裸 input/textarea 的收编目标)。 */
const base =
	"w-full rounded-lg border border-surface-border bg-surface-card text-sm text-text-primary placeholder:text-text-muted transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-state-focus focus:ring-offset-1 ring-offset-surface-background disabled:cursor-not-allowed disabled:opacity-50";

export const Input = React.forwardRef<
	HTMLInputElement,
	React.InputHTMLAttributes<HTMLInputElement>
>(({ className, ...props }, ref) => (
	<input ref={ref} className={cn(base, "h-8 px-2.5", className)} {...props} />
));
Input.displayName = "Input";

export const Textarea = React.forwardRef<
	HTMLTextAreaElement,
	React.TextareaHTMLAttributes<HTMLTextAreaElement>
>(({ className, ...props }, ref) => (
	<textarea ref={ref} className={cn(base, "min-h-[72px] px-2.5 py-2", className)} {...props} />
));
Textarea.displayName = "Textarea";
